
import style from "./style.module.css"
import StudentProfile from "../../../assets/student-profile.svg"
import DashboardClassInfo from "../../../assets/dashboard-classinfo.svg"
import DashboardExam from "../../../assets/dashboard-exam.svg"
// import DashboardResult from "../../../assets/dashboard-result.svg"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet";
import { useState } from "react"
import Logout from "./Logout"
const Dashboard = () => {
    const studentData = useSelector(store => store.AuthReducer.studentData)
    const [isLogout, setIsLogout] = useState(false)
    const getGreeting = () => {
        const hours = new Date().getHours();
        if (hours > 5 && hours < 12) {
            return "Good Morning"
        }
        else if (hours > 12 && hours < 17) {
            return "Good Afternoon"
        }
        else {
            return "Good Evening"
        }
    }
    return (
        <div className={style.mainDiv}>
            {
                isLogout
                &&
                <Logout closePopup={()=>setIsLogout(false)} />
            }
            <Helmet>
                <title>Dashboard | Secure Examination</title>
            </Helmet>
            <div className={style.leftSection}>
                <img className={style.studentImg} src={StudentProfile} alt="..." />
                <p className={style.studentName}>Hello.! {studentData.name}. {getGreeting()}.</p>
                <p className={style.className}>{studentData.c_id.name}</p>
                <p className={style.batch}><span className={style.infoHeading}>Batch:</span> {`${new Date(studentData.c_id.startDate).getFullYear()}-${new Date(studentData.c_id.endDate).getFullYear()}`}</p>
                <p className={style.classTeacherName}><span className={style.infoHeading}>Class Teacher:</span> {studentData.c_id.classTeacher.name}</p>
                <button onClick={()=>setIsLogout(true)} className={style.logoutBtn}>Log out</button>
            </div>
            <div className={style.rightSection}>
                <Link to="/classInfo" className={style.dashboardCard}>
                    <img className={style.cardImg} src={DashboardClassInfo} alt="..." />
                    <p className={style.cardLabel}>Class Information</p>
                </Link>
                <Link to="/exams" className={style.dashboardCard}>
                    <img className={style.cardImg} src={DashboardExam} alt="..." />
                    <p className={style.cardLabel}>Exams</p>
                </Link>
                {/* <Link to="/results" className={style.dashboardCard}>
                    <img className={style.cardImg} src={DashboardResult} alt="..." />
                    <p className={style.cardLabel}>Results</p>
                </Link> */}
            </div>
        </div>
    )
}

export default Dashboard;